import { Constrain } from '@/components/Constrain';
import { Card, CardInner } from '@/components/Card';
import { ClientForm } from '@/components/forms/ClientForm';
import { Text } from '@shared/components/ui/Text';

/** Port of the `client/create` route. */
export function CreateClientPage() {
    return (
        <Constrain width="narrow">
            <Card>
                <CardInner>
                    <Text as="h2" size="large" font="primary" weight="bold" color="uNavy">
                        Create new client
                    </Text>
                </CardInner>
                <CardInner>
                    <ClientForm />
                </CardInner>
            </Card>
        </Constrain>
    );
}
